export default function RightArrowRoundedIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19.1663C15.0626 19.1663 19.1667 15.0623 19.1667 9.99967C19.1667 4.93706 15.0626 0.833008 10 0.833008C4.9374 0.833008 0.833344 4.93706 0.833344 9.99967C0.833344 15.0623 4.9374 19.1663 10 19.1663Z"
        stroke="#8C8B8B"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.845 13.2363L12.0717 10.0005L8.845 6.76465"
        stroke="#8C8B8B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
